import type { QueryClient } from "@tanstack/react-query";

import { AbsoluteCenter, Spinner } from "@chakra-ui/react";
import { createRouter } from "@tanstack/react-router";

import { Template } from "@app/navigation/template";
import { ErrorPageConnector } from "@pages/error";
import { NotFoundPageConnector } from "@pages/not-found";

import { routeTree } from "./routeTree.gen";

export const makeRouter = (queryClient: QueryClient) =>
  createRouter({
    context: {
      getAuthStatus: () => false,
      hasFeatureFlag: () => true,
      queryClient,
    },
    defaultErrorComponent: ErrorPageConnector,
    defaultNotFoundComponent: () =>
      Template({ children: NotFoundPageConnector() }),
    defaultPendingComponent: () => (
      <AbsoluteCenter>
        <Spinner size="xl" />
      </AbsoluteCenter>
    ),
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    routeTree,
    scrollRestoration: true,
  });
